"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DIALOG_WIDTH = exports.CDialog = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Dialog = _interopRequireDefault(require("@mui/material/Dialog"));
var _DialogActions = _interopRequireDefault(require("@mui/material/DialogActions"));
var _DialogTitle = _interopRequireDefault(require("@mui/material/DialogTitle"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _TitleHelpMark = _interopRequireDefault(require("./TitleHelpMark"));
const _excluded = ["open", "handleClose", "help", "title", "children", "actions", "customClasses", "width"],
  _excluded2 = ["disableBackdropClick"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const DialogTitleRoot = (0, _styles.styled)(_DialogTitle.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: "1px solid ".concat(theme.palette.divider),
    backgroundColor: theme.palette.cardHeader.main,
    height: 36
  };
});
const TitleContainer = (0, _styles.styled)('div')({
  display: 'flex',
  fontWeight: 'normal',
  alignItems: 'center',
  verticalAlign: 'middle'
});
const CloseButton = (0, _styles.styled)(_IconButton.default)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    display: 'flex',
    color: theme.palette.cardHeader.contrastText,
    marginRight: -8
  };
});
const ActionItem = (0, _styles.styled)(_Grid.default)(_ref3 => {
  let {
    theme
  } = _ref3;
  return {
    marginLeft: theme.spacing(2)
  };
});

/**
 * ダイアログの表示サイズ
 */
const DIALOG_WIDTH = exports.DIALOG_WIDTH = {
  MIDDLE: 'md'
};

/**
 * 内部コンポーネント：ダイアログ用タイトル
 */
const CDialogTitle = props => {
  const {
    children,
    help,
    onClose
  } = props;
  return /*#__PURE__*/_react.default.createElement(DialogTitleRoot, null, /*#__PURE__*/_react.default.createElement(TitleContainer, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "subtitle1",
    color: "text.secondary"
  }, children), help && /*#__PURE__*/_react.default.createElement(_TitleHelpMark.default, {
    help: help
  })), onClose && /*#__PURE__*/_react.default.createElement(CloseButton, {
    "aria-label": "Close",
    onClick: onClose
  }, /*#__PURE__*/_react.default.createElement(_Close.default, null)));
};

/**
 * ダイアログ部品
 * @prop {bool} open - 開閉フラグ
 * @prop {node} [help] - ヘルプ表示内容
 * @prop {func} handleClose - 開閉フラグをオフにするイベント<br/>
 * シグネチャ:():void
 * @prop {string} title - タイトル
 * @prop {object} customClasses - DialogAPIにclassesで指定する値
 */
class CDialog extends _react.default.Component {
  render() {
    const _this$props = this.props,
      {
        open,
        handleClose,
        help,
        title,
        children,
        actions,
        customClasses,
        width
      } = _this$props,
      rest = _objectWithoutProperties(_this$props, _excluded);
    const {
        disableBackdropClick
      } = rest,
      passthrough = _objectWithoutProperties(rest, _excluded2);
    return /*#__PURE__*/_react.default.createElement(_Dialog.default, _extends({
      maxWidth: width,
      fullWidth: true
    }, passthrough, {
      open: open,
      classes: customClasses
    }), /*#__PURE__*/_react.default.createElement(CDialogTitle, {
      help: help,
      onClose: handleClose,
      id: "form-dialog-title"
    }, title), children && children, Array.isArray(actions) && actions.length > 0 && /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, actions.map((item, index) => {
      return /*#__PURE__*/_react.default.createElement(ActionItem, {
        size: {
          xs: 'auto'
        },
        key: 'DialogActions_' + index
      }, item);
    })));
  }
}
exports.CDialog = CDialog;
CDialog.propTypes = {
  title: _propTypes.default.string.isRequired,
  help: _propTypes.default.node,
  actions: _propTypes.default.array,
  open: _propTypes.default.bool.isRequired,
  handleClose: _propTypes.default.func.isRequired,
  customClasses: _propTypes.default.object,
  width: _propTypes.default.string
};
CDialog.defaultProps = {
  width: DIALOG_WIDTH.MIDDLE
};
var _default = exports.default = CDialog;